import Digests from './Digests';

export default Digests;